export default () => ({
  user: null,
  mapStyle: 'mapbox://styles/mapbox/streets-v11?optimize=true',
  allProjects: [],
  me: null
});
